import { MobileApp } from "services/mobileAppsPortal/response";

type MobileAppProperty = keyof MobileApp;

export  const appName: MobileAppProperty = "name";
export  const appDescription: MobileAppProperty = "description";
export  const androidLink: MobileAppProperty = "linkAndroid";
export  const iosLink: MobileAppProperty = "linkIOS";
export  const androidVersion: MobileAppProperty = "versionAndroid";
export  const iosVersion: MobileAppProperty = "versionIOS";
export  const ePoljoprivredaName: MobileAppProperty = "ePoljoprivredaName";
export  const ePoljoprivredaId: MobileAppProperty = "ePoljoprivredaId";